interface CategoryPinProps {
  pinType: "ICON" | "LOGO";
  iconColor?: string;
  iconName?: string;
  logoUrl?: string;
  size?: number;
  showStroke?: boolean;
  strokeWidth?: number;
  strokeColor?: string;
  iconFontSize?: number;
  className?: string;
  alt?: string;
  isRenderedView?: boolean;
}

const CategoryPin = ({
  pinType,
  iconColor = "#a23f97",
  iconName,
  logoUrl,
  size = 24,
  showStroke = true,
  strokeWidth = 2,
  strokeColor = "white",
  iconFontSize,
  className = "",
  alt = "Category pin",
  isRenderedView = false,
}: CategoryPinProps) => {
  // ViewBox is always a fixed 24-unit coordinate space regardless of rendered size.
  // All SVG coordinates (circle cx/cy, text x/y) are in viewBox units, not pixels.
  const viewBoxSize = 24;
  // Font size in viewBox units — must use viewBoxSize, not the rendered `size` prop
  const calculatedIconFontSize =
    iconFontSize || Math.round(viewBoxSize * (16 / 24)); // = 16

  // Render LOGO pin
  if (pinType === "LOGO" && logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={alt}
        className={`shrink-0 object-contain ${!isRenderedView ? "h-full" : "mt-3"} ${className}`}
        style={{
          display: "block",
          width: `${size}px`,
          ...(!isRenderedView && { height: `${size}px` }),
        }}
      />
    );
  }

  // Render ICON pin
  // ViewBox needs to be slightly larger to accommodate stroke
  const viewBoxOffset = showStroke ? -strokeWidth / 2 : 0;
  const viewBox = `${viewBoxOffset} ${viewBoxOffset} ${viewBoxSize + Math.abs(viewBoxOffset) * 2} ${viewBoxSize + Math.abs(viewBoxOffset) * 2}`;

  return (
    <svg
      width={size}
      height={isRenderedView ? size * 2 : size}
      viewBox={viewBox}
      className={`shrink-0 ${className} ${isRenderedView && "mt-1 overflow-visible"}`}
      style={{ display: "block" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="12"
        fill={iconColor}
        stroke={showStroke ? strokeColor : "none"}
        strokeWidth={showStroke ? strokeWidth : 0}
      />
      {iconName && iconName !== "circle" && (
        <text
          x="12"
          y="12"
          textAnchor="middle"
          dominantBaseline="central"
          fontFamily="Material Icons"
          fontSize={calculatedIconFontSize}
          fill="white"
        >
          {iconName}
        </text>
      )}
    </svg>
  );
};

export default CategoryPin;
